$(document).ready(function () {

	$('[phone-ddd]').mask('00');
	$('[phone]').mask('00000-0000');
	$('.oneDecimalMask').mask("#.0", { reverse: true });
	$('.twoDecimalMask').mask("#.00", { reverse: true });
	$('.moneyMask').mask("#,##0.00", { reverse: true });

	var header = new Header();

	if ($('.compartilhar').length > 0) {
		var url = window.location.href;

		$('.compartilhar a').each(function(){
			var href = $(this).attr('href');
			href = href + encodeURIComponent(url);
			$(this).attr('href', href);
		});
	}

	if ($('[data-component="slider"]').length > 0) {
		var slider = new Slider();
	}

	if ($('[data-component="card-list"]').length > 0) {
		var cardList = new CardList();
	}

	if ($('[data-component="card-item"]').length > 0) {
		var cardItem = new CardItem();
	}

	if ($('[data-component="maps-search"]').length > 0) {
		var mapsSearch = new MapsSearch();
	}

	if ($('[data-component="maps-location"]').length > 0) {
		var mapsLocation = new MapsLocation();
	}

	if ($('[data-component="tabs"]').length > 0) {
		var tabs = new Tabs();
	}

	if ($('[data-component="filters"]').length > 0) {
		var filter = new Filters();
	}

	if ($('[data-component="accordion"]').length > 0) {
		var accordion = new Accordion();
	}

	if ($('[data-component="calculator"].gears').length > 0) {
		var calculatorGears = new CalculatorGears();
	}

	if ($('[data-component="calculator"].air-compressor').length > 0) {
		var calculatorAirCompressor = new CalculatorAirCompressor();
	}

	if ($('[data-component="calculator"].bearings').length > 0) {
		var calculatorBearings = new CalculatorBearings();
	}

	if ($('[data-component="calculator"].electric-motor-bearings').length > 0) {
		var calculatorElectricMotorBearings = new CalculatorElectricMotorBearings();
	}

	if ($('[data-component="calculator"].hydraulics').length > 0) {
		var calculatorHydraulics = new CalculatorHydraulics();
	}

	if ($('[data-component="calculator"].gas-engines').length > 0) {
		var calculatorGasEngines = new CalculatorGasEngines();
	}

	if ($('[data-component="form"]').length > 0) {
		var form = new Form();
	}

	if ($('[data-component="equipment-search"]').length > 0) {
		var equipmentSearch = new EquipmentSearch();
	}

	if ($('[data-component="properties"]').length > 0) {
		var properties = new Properties();
	}

	if ($('[data-component="share"]').length > 0) {
		var share = new Share();
	}

	if ($('[data-component="newsletter-form"]').length > 0) {
		var newsletterForm = new NewsletterForm();
	}

	if ($('[data-component="modal-login"]').length > 0) {
		var modalLogin = new ModalLogin();
	}

	if ($('[data-component="login-form"]').length > 0) {
		var loginForm = new LoginForm();
	}

	if ($('[data-component="cadastro-form"]').length > 0) {
		var cadastroForm = new CadastroForm();
	}

	if ($('[data-component="esqueci-senha-form"]').length > 0) {
		var esqueciSenhaForm = new EsqueciSenhaForm();
	}

	if ($('[data-component="perfil-form"]').length > 0) {
		var esqueciSenhaForm = new PerfilForm();
	}

	if ($('[data-component="artigo-testemunhal"]').length > 0) {
		var artigoTestemunhal = new ArtigoTestemunhal();
	}

	if ($('[data-component="testemunhal-search"]').length > 0) {
		var testemunhalSearch = new TestemunhalSearch();
	}

	if ($('[data-component="slider-blog"]').length > 0) {
		var sliderBlog = new SliderBlog();
	}

	if ($('[data-component="blog-search"]').length > 0) {
		var blogSearch = new BlogSearch();
	}
	

	if ($('[data-component="artigo-blog"]').length > 0) {
		var artigoBlog = new ArtigoBlog();
	}

	if ($('[data-component="artigo-inteligencia"]').length > 0) {
		var artigoInteligencia = new ArtigoInteligencia();
	}

	if ($('[data-component="institucional"]').length > 0) {
		var institucional = new Institucional();
	}

	if ($('[data-component="blog-conteudo-artigo"]').length > 0) {
		var blogConteudoArtigo = new BlogConteudoArtigo();
	}

	if ($('[data-component="card-answer"]').length > 0) {
		var cardAnswer = new CardAnswer();
	}

	if ($('[data-component="filter-bar"]').length > 0) {
		var filterBar = new FilterBar();
	}

	if ($('[data-component="energy-widget"]').length > 0) {
		var energyWidget = new EnergyWidget();
	}

	if ($('[data-component="product-search"]').length > 0) {
		var productComponent = new ProductComponent();
	}

	if ($('[data-component="manufacturers"]').length > 0 || $('[data-component="equipment-search"]').length > 0) {
		var manufacturer = new Manufacturers();
	}

	if ($('[data-component="inline-search"]').length > 0) {
		var search = new Search();
	}

	if ($('[data-component="downloadable-item-list"]').length > 0) {
		var downloadableItems = new DownloadableItems();
	}

	$('img.svg').each(function () {

		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');

		$.get(imgURL, function (data) {
			// Get the SVG tag, ignore the rest
			var $svg = $(data).find('svg');

			// Add replaced image's ID to the new SVG
			if (typeof imgID !== 'undefined') {
				$svg = $svg.attr('id', imgID);
			}

			// Add replaced image's classes to the new SVG
			if (typeof imgClass !== 'undefined') {
				$svg = $svg.attr('class', imgClass + ' replaced-svg');
			}

			// Remove any invalid XML tags as per http://validator.w3.org
			$svg = $svg.removeAttr('xmlns:a');

			// Check if the viewport is set, else we gonna set it if we can.
			if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
				$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
			}

			// Replace image with new SVG
			$img.replaceWith($svg);

		}, 'xml');
	});

	if ($(window).width() > 992) {
		$(".main-menu a").on("click", function (e) {

			var dataSubmenuId = $(this).data("submenu");
			var submenu = $("[data-component='submenu']").find("[data-submenu='" + dataSubmenuId + "']");

			setTimeout(function () {

				var arrHeight = [];

				$(submenu).find(".submenu-main-menu").each(function () {
					var height = $(this).height();
					if (height > 0) {
						arrHeight.push(height);
					}
				});

				$(submenu).find(".submenu-main-menu").height(Math.max.apply(null, arrHeight));
			}, 100);
		});
	}

	$(".header-search").submit(function (e) {

		e.preventDefault();

		query = $(this).find("input").val();

		window.location.href = window.location.origin + "/resultado-de-busca/?s=" + query;
	});

	checkNewTabLinks($("a"));
});

var checkNewTabLinks = function (links) {

	for (var i = 0; i < links.length; i++) {

		var _this = links[i];

		var a = new RegExp('/' + window.location.host + '/');

		var href = _this.href;
		var extension = _this.href.substring(_this.href.lastIndexOf('.') + 1);
		var extensionTab = false;

		if (extension.toLowerCase().includes("jpg") || extension.toLowerCase().includes("png") || extension.toLowerCase().includes("gif") || extension.toLowerCase().includes("pdf")) {
			extensionTab = true;
		}

		if (!a.test(_this.href) && _this.href != "" && _this.href != "#" && _this.href != "javascript:void(0)" || extensionTab) {
			$(_this).click(function (event) {
				event.preventDefault();
				event.stopPropagation();

				if (this.href.match("^mailto")) {
					window.open(this.href, '_top');
				}
				else {
					window.open(this.href, '_blank');
				}
			});
		}
	}
}